import { Typography } from 'antd';
import React from 'react';

const CoursePill: React.FC<{ name: string }> = ({ name }) => (
  <Typography.Text
    className="rounded-sm bg-blue-50 px-2 py-1 text-primary-700"
    ellipsis={{ tooltip: name }}>
    {name}
  </Typography.Text>
);

export default CoursePill;
